import { render } from "./privacy.vue?vue&type=template&id=103ad32f&ts=true"
import script from "./privacy.vue?vue&type=script&lang=ts"
export * from "./privacy.vue?vue&type=script&lang=ts"

import "./privacy.vue?vue&type=style&index=0&id=103ad32f&lang=less"

import exportComponent from "/Users/coohua/shiNet/g1-pro/g1-privacy-pro/privacy2H5Source/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__